/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Consent_Terms_LinkInputs */

const en_checkout_consent_terms_link = /** @type {(inputs: Checkout_Consent_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking Terms`)
};

/**
* | output |
* | --- |
* | "Booking Terms" |
*
* @param {Checkout_Consent_Terms_LinkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_consent_terms_link = /** @type {((inputs?: Checkout_Consent_Terms_LinkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Consent_Terms_LinkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_consent_terms_link(inputs)
});